var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIsLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 205.315,
    height: 123.642,
    viewBox: "0 0 205.315 123.642",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#eaf2ff;}.b{fill:#feffff;}.c{fill:#dde3ed;}.d{fill:url(#a);}.e{fill:url(#b);}.f{fill:url(#c);}.g{fill:#d8deff;}.h{fill:url(#d);}.i{fill:url(#e);}.j{fill:url(#f);}.k{fill:url(#i);}.l{fill:#5792f5;}.m{fill:url(#k);}.n{fill:#c5d9fe;}.o{fill:#e2ebff;}.p{fill:#d0e0ff;}.q{fill:#e9f3fc;}.r{fill:#d2e1ff;}.s{filter:url(#g);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 0.423,
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#90baf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71a5fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    y1: 0.423,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#478fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357dfc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0.578,
    cy: 0.5,
    r: 0.391,
    gradientTransform: "translate(0.068 0) scale(0.882 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5797fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#3173f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3772f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#99bcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcd5ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.275,
    y1: 0.083,
    x2: 0.819,
    y2: 0.904,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6deff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3d0ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.2,
    y1: 0.264,
    x2: 0.828,
    y2: 0.821,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb559f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef234d"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 82.195,
    y: 25.2,
    width: 7.2,
    height: 7.2,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "h"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#5cbbd5",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "h"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.475,
    y1: 0.481,
    x2: 0.544,
    y2: 0.527,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6ca9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4782f3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#80b5f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7cb1ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-76 -268)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M59.875,63.609h-47.7c-9.328.905-19.841-16.3-4.068-26.5-2.532-1.7-1.7-10.123,4.068-12.282C7.085,10.488,5.375-1,21.105.07s12.142,14.737,6.925,20.2c.527,1.339,4.194,5.871,4.738,9.918,0,0,8.5,1.209,11.314,12.07,0,.472,15.234-.8,26.72,4.022s36.16,3.938,36.16,3.938V63.609Z",
    transform: "translate(76 327.691)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.72,0a.72.72,0,0,1,.715.636l0,.084V12.575L6.781,7.552a.72.72,0,0,1,1.049.983L7.767,8.6,1.44,14.552V24.583A.72.72,0,0,1,0,24.667l0-.084V.72A.72.72,0,0,1,.72,0Z",
    transform: "translate(94.145 337.228)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(129.035 268)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1,34.095a.9.9,0,0,1-.9-.828C.033,32.442,0,31.606,0,30.78A30.756,30.756,0,0,1,30.78,0a31.3,31.3,0,0,1,3.337.179.9.9,0,0,1-.1,1.795.884.884,0,0,1-.1-.005A29.569,29.569,0,0,0,30.78,1.8,28.954,28.954,0,0,0,1.8,30.78c0,.778.031,1.567.094,2.344a.9.9,0,0,1-.825.968Zm7.2-.722a.894.894,0,0,1-.894-.818c-.064-.7-.1-1.418-.1-2.135A23.2,23.2,0,0,1,30.42,7.2a23.723,23.723,0,0,1,2.526.136.9.9,0,1,1-.194,1.789A21.992,21.992,0,0,0,30.42,9,21.4,21.4,0,0,0,9,30.42c0,.662.03,1.325.089,1.972a.9.9,0,0,1-.814.977C8.25,33.372,8.222,33.373,8.191,33.373Zm6.674-.389a.9.9,0,0,1-.893-.8,17.154,17.154,0,0,1-.112-1.947A16.739,16.739,0,0,1,30.6,13.5a17,17,0,0,1,2.354.164.9.9,0,0,1,.766,1.017.9.9,0,0,1-1.017.766,15.04,15.04,0,0,0-2.1-.147,14.94,14.94,0,0,0-14.94,14.94,15.157,15.157,0,0,0,.1,1.74.9.9,0,0,1-.79,1A.912.912,0,0,1,14.864,32.984Z",
    transform: "translate(3.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M34.581,0l-.72,40.824H0L32.1,0Z",
    transform: "translate(32.891 77.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M32.421,0V40.824H0Z",
    transform: "translate(35.051 77.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M90.476.733c.466.767,1.555.6,1.986,1.392A57.946,57.946,0,0,1,.412,70.62c-.552-.557.117-1.7-.412-2.283C16.2,32.03,48.935,5.963,89.6,0Z",
    transform: "translate(1.599 14.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1.3,73.343c6.006,7.688,31.13-1.9,56.115-21.425S97.785,10.34,91.779,2.652s-31.13,1.9-56.115,21.425S-4.707,65.655,1.3,73.343Z",
    transform: "translate(1.578 12.411)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1.1,72.949c4.531,5.8,21.978.058,41.888-12.959l1.461-.965c3.175-2.12,6.4-4.42,9.648-6.883l1.5-1.148.749-.583c3.248-2.538,6.34-5.11,9.251-7.68l1.33-1.186A153.943,153.943,0,0,0,80.661,27.621l.941-1.11C90.688,15.647,94.843,6.432,91.582,2.259,86.057-4.814,61.323,5.277,36.337,24.8A176.434,176.434,0,0,0,13.5,45.9l-.991,1.126C2.439,58.611-2.323,68.564,1.1,72.949Z",
    transform: "translate(0.524 11.799)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M3.389,0,4.51,1.419l.216-.382L41.517,21.713l-1.061.993h0l-1.11,1.026h0L38.183,24.8,10.846,9.431,29.139,32.565l-1.625,1.295h0l-1.761,1.388h0L9.6,14.825,16.1,42.25l-1.781,1.184q-1.018.679-2.055,1.356l-9-37.978L0,2.68Z",
    transform: "translate(30.223 27.667)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "s",
    transform: "matrix(1, 0, 0, 1, -53.04, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 3.6,
    cy: 3.6,
    r: 3.6,
    transform: "translate(82.2 25.2)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M34.581,0l-.72,40.824H0L32.1,0Z",
    transform: "translate(46.571 77.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M32.421,0V40.824H0Z",
    transform: "translate(48.731 77.305)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 1.44,
    cy: 1.44,
    r: 1.44,
    transform: "translate(76.68 84.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 85.68,
    height: 5.04,
    transform: "translate(14.04 118.26)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224.435 348.1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M13.77,18.482h0A42.382,42.382,0,0,1,3.943,9.506,18.774,18.774,0,0,1,0,.216,19.013,19.013,0,0,1,2.767,0a9.75,9.75,0,0,1,7.728,3.145c1.821,2.087,2.914,5.261,3.249,9.435l.05.722a43.262,43.262,0,0,1,.019,4.328l-.043.851ZM3.863,2.9a.347.347,0,0,0-.3.519l.047.065,8.986,9.667.035.032a.348.348,0,0,0,.456-.014.35.35,0,0,0,.065-.427l-.048-.064L4.117,3.009l-.034-.032A.347.347,0,0,0,3.863,2.9Z",
    transform: "translate(0.639 25.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M11.624,33.84h0A65.943,65.943,0,0,1,1.717,15.66,34.194,34.194,0,0,1,.068,7.515,25.559,25.559,0,0,1,.623,0,24.04,24.04,0,0,1,8.851,2.968,14.019,14.019,0,0,1,13.9,8.205a18.749,18.749,0,0,1,1.78,10.73,52.692,52.692,0,0,1-4.06,14.9ZM4.77,5.869h0a.54.54,0,0,0-.524.666l.031.093L12.6,25.4l.034.065a.542.542,0,0,0,.459.256.541.541,0,0,0,.525-.667l-.031-.092L5.264,6.192,5.23,6.126a.544.544,0,0,0-.46-.256Z",
    transform: "translate(2.776 9.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M13.68,43.2H0V0H22.32V13.68H36V43.2Z",
    transform: "translate(20.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M15.84,43.2H0V0H22.32V13.68H38.16V43.2Z",
    transform: "translate(14.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M20.88,33.84V30.96h9.36v2.88ZM0,31.68v-3.6H12.96v3.6Zm20.88-4.32V24.48h9.36v2.88ZM0,22.32v-3.6H12.96v3.6Zm20.88-1.44V18h9.36v2.88Zm0-6.48V11.52h9.36V14.4ZM0,12.96V9.36H12.96v3.6ZM0,3.6V0H12.96V3.6Z",
    transform: "translate(18.72 5.76)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsLogin);
export default __webpack_public_path__ + "static/media/isLogin.1bf566ee7afd527a1d52624cf49a848d.svg";
export { ForwardRef as ReactComponent };